import React from 'react';
import { SvgIcon } from '@material-ui/core';
type Props = {
  className?: string;
};
const WarningIcon = (props: Props) => (
  <SvgIcon width='80' height='80' viewBox='0 0 80 80' fill='none' {...props}>
    <circle cx='40' cy='40' r='40' fill='#F9F9FA' />
    <path
      d='M41 60C52.0457 60 61 51.0457 61 40C61 28.9543 52.0457 20 41 20C29.9543 20 21 28.9543 21 40C21 51.0457 29.9543 60 41 60Z'
      fill='#FEC9C1'
    />
    <path
      d='M43 52.0698C43 53.135 42.0962 54 41.0116 54C39.9038 54 39 53.135 39 52.0698C39 50.9818 39.9038 50.1168 41.0116 50.1168C42.0962 50.1168 43 50.9818 43 52.0698ZM42.5025 29.5737L42.5025 44.258C42.5025 45.1897 41.8923 45.8331 41.0116 45.8331C40.1309 45.8331 39.5206 45.1897 39.5206 44.258C39.5206 43.3262 39.5206 29.5751 39.5206 29.5751C39.5206 28.6434 40.1309 28 41.0116 28C41.8923 28 42.5025 28.642 42.5025 29.5737Z'
      fill='#1B3642'
    />
  </SvgIcon>
);
export default WarningIcon;
